import moment from 'moment';

/**
 * Splits string by '\n' (new-line) separator. It returns the results as array.
 * If param text is empty, return value will be empty array
 *
 * @param {String} text Text to split
 * @return {String[]}
 */
const textToParagraphs = (text = null) => {
    if (!text) {
        return [];
    }

    return text.split('\n').map((line) => {
        return line.trim();
    });
};

/**
 * Get's past months' date set to start of month.
 *
 * @return {Date}
 */
const pastMonthDate = () => {
    return monthsAgoDate(1);
};

/**
 * Get's past years' date set to start of year.
 *
 * @return {Date}
 */
const pastYearDate = () => {
    return yearsAgoDate(1);
};

/**
 * Get's current years' date set to beginning of current year.
 *
 * @return {Date}
 */
const currentYearDate = () => {
    return yearsAgoDate(0);
};

/**
 * Returns start-of-motnh date for <monthsCount> months ago.
 *
 * @param {int} monthsCount
 */
const monthsAgoDate = monthsCount => {
    return moment()
        .subtract(monthsCount, 'months')
        .startOf('month')
        .toDate();
};

/**
 * Returns start-of-year date for <yearsCount> years ago.
 *
 * @param {int} yearsCount
 */
const yearsAgoDate = (yearsCount) => {
    return moment()
        .subtract(yearsCount, 'years')
        .startOf('year')
        .toDate();
};

const toApiMonthString = (date) => {
    return moment(date).format('Y-MM');
};

const toApiMonthYear = (date) => {
    return moment(date).format('Y-MM');
};



/**
 * Returns query string as json object.
 *
 * @param {string} search // preferably window.location.search
 */
const decodeURLParams = (search = null) => {

    if (search === null) {
        search = window.location.search;
    }

    const hashes = search.slice(search.indexOf('?') + 1).split('&');

    return hashes.reduce((params, hash) => {

        const split = hash.indexOf('=');

        if (split < 0) {
            return Object.assign(params, {
                [hash]: null,
            });
        }

        const key = hash.slice(0, split);
        const val = hash.slice(split + 1);

        return Object.assign(params, {
            [key]: decodeURIComponent(val),
        });
    }, {});
};


const roundDateToPeriod = (date, periodNameStartingChar) => {

    let momentDate = moment(date);

    // Static or Yearly
    if (periodNameStartingChar === 'S' || periodNameStartingChar === 'Y') {
        return momentDate.startOf('year').toDate();
    }

    // Monthly
    if (periodNameStartingChar === 'M') {
        return momentDate.startOf('month').toDate();
    }

};

const roundTo = (x, decimals = 2, forceDecimal = false) => {

    // handle null?
    if (x === null) {
        return x;
    }

    if (Number.isInteger(x) && !forceDecimal) {
        return x;
    }

    let number = Math.round((x + Number.EPSILON) * 100) / 100;
    return number.toFixed(decimals);
};

export default {
    methods: {
        decodeURLParams,
        textToParagraphs,
        pastMonthDate,
        monthsAgoDate,
        pastYearDate,
        currentYearDate,
        toApiMonthString,
        toApiMonthYear,
        roundDateToPeriod,
        roundTo,
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/mixins/UtilsMixin.js